import { SHUFFLE, LINEAR, REPEAT, REPEAT_1 } from '../store/types'
import UIkit from 'uikit'
import { Track } from '../models/track'
import { t } from '../store/reducers/songsReducer'

export const randomColor = () => {
  let color = '#'
  const vals = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'a', 'b', 'c', 'd', 'e', 'f']

  while (color.length < 7) {
    color += vals[Math.floor(Math.random() * vals.length)]
  }
  return color
}

export const findNext = (
  current: Track,
  where: Track[],
  mode: typeof SHUFFLE | typeof LINEAR | typeof REPEAT | typeof REPEAT_1,
  next = true
): Track => {
  let ret: Track = t
  let i: number
  if (next) {
    i = where.indexOf(current)
    switch (mode) {
      case SHUFFLE:
        ret = where[Math.abs(Math.floor(Math.random() * where.length))]
        break
      case REPEAT:
        if (i === where.length - 1) {
          ret = where[0]
        } else if (where.length > 0) {
          i++
          ret = where[i]
        }
        break
      case REPEAT_1:
        ret = current
        break
      case LINEAR:
      default:
        if (where.length > 0 && i < where.length - 1) {
          i++
          ret = where[i]
        } else {
          ret = current
        }
        break
    }
    return ret
  } else {
    i = where.indexOf(current)
    switch (mode) {
      case SHUFFLE:
        ret = where[Math.abs(Math.floor(Math.random() * where.length))]
        break
      case LINEAR:
        if (i === 0) {
          ret = current
        } else {
          i--
          ret = where[i]
        }
        break
      case REPEAT:
        if (i === 0) {
          ret = where[where.length - 1]
        } else if (where.length > 0) {
          i--
          ret = where[i]
        } else {
          ret = t
        }
        break
      case REPEAT_1:
      default:
        ret = current
        break
    }
    return ret
  }
}

export const closeModal = (id: string) => {
  const modal = document.querySelectorAll(`#${id}`)
  // const modal = UIkit.modal(m)
  // if (modal.isToggled()) {
  //   modal.show()
  // } else {
  //   modal.hide()
  // }
  UIkit.modal(modal).hide()
}

export const closeDrops = () => {
  const elements = document.querySelectorAll('.uk-dropdown')
  elements.forEach((el) => {
    UIkit.dropdown(el).hide()
  })
}
